// SPDX-License-Identifier: AGPL-3.0-or-later

import {GenericErrorModal} from '@app/features/app/components/alerts/GenericErrorModal';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
export const VoiceChannelFullModal = observer(() => {
	const {t} = useLingui();
	return (
		<GenericErrorModal
			title={t`Voice Channel Full`}
			message={t`This voice channel has reached its user limit. Please try again later or join a different channel.`}
		/>
	);
});
